import { SubscriptionLinesTabEnum } from 'types/subscriptionLines';
import { generatedApi } from './api.generated';
import { UpdateStatus } from 'types/general';
import CacheTag from './cacheTags';

export const api = generatedApi.enhanceEndpoints({
  endpoints: {
    listSubscriptionStandards: {
      providesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
        {
          type: CacheTag.SubscriptionLines,
          id: `${subscriptionId}:${SubscriptionLinesTabEnum.Standards}`,
        },
        // TODO: Should this be removed?
        {
          type: CacheTag.SubscriptionLines,
          id: `${subscriptionId}:${SubscriptionLinesTabEnum.Collections}`,
        },
      ],
    },
    listSubscriptionCollections: {
      providesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
        {
          type: CacheTag.SubscriptionLines,
          id: `${subscriptionId}:${SubscriptionLinesTabEnum.Collections}`,
        },
      ],
    },
    listSubscriptionEforms: {
      providesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
        {
          type: CacheTag.SubscriptionLines,
          id: `${subscriptionId}:${SubscriptionLinesTabEnum.Eforms}`,
        },
      ],
    },
    getSubscription: {
      providesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
      ],
    },
    reactivateSubscription: {
      invalidatesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
      ],
    },
    deactivateSubscription: {
      invalidatesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
      ],
    },
    discontinueSubscription: {
      invalidatesTags: (_result, _error, { subscriptionId }) => [
        { type: CacheTag.Subscription, id: subscriptionId },
      ],
    },
    searchProducts: {
      serializeQueryArgs: ({ queryArgs, endpointName }) => {
        if (queryArgs.query && queryArgs.subscriptionId && endpointName) {
          return `${endpointName}-${queryArgs.subscriptionId}-${queryArgs.query}`;
        }
        return '';
      },
      merge: (currentCache, newItems) => {
        currentCache.items?.push(...(newItems.items ?? []));
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },
    },
    addProductToSubscription: {
      invalidatesTags: (_result, error, { subscriptionId }) => {
        if (error) {
          return [];
        }
        return [
          {
            type: CacheTag.SubscriptionLines,
            id: `${subscriptionId}:${SubscriptionLinesTabEnum.Standards}`,
          },
          {
            type: CacheTag.SubscriptionLines,
            id: `${subscriptionId}:${SubscriptionLinesTabEnum.Collections}`,
          },
          {
            type: CacheTag.SubscriptionLines,
            id: `${subscriptionId}:${SubscriptionLinesTabEnum.Eforms}`,
          },
        ];
      },
      onQueryStarted: async (
        // We are adding the query to locate the right RTK Query cache in order to add state to the row.
        // @ts-expect-error We ignore because the type is auto-generated, and the back end doesn't know about the query.
        { addProductRequest, query, subscriptionId },
        { dispatch, queryFulfilled },
      ) => {
        if (!query || typeof query !== 'string') {
          return;
        }

        dispatch(
          api.util.updateQueryData(
            'searchProducts',
            { query, subscriptionId },
            (draft) => {
              const rowToUpdate = draft.items.find(
                (row) => row.id === addProductRequest.productId,
              );
              // We are setting the state property in the front end to style the loading state.
              // @ts-expect-error We ignore because the type is auto-generated, and the back end doesn't know about the state.
              rowToUpdate.state = UpdateStatus.Loading;
            },
          ),
        );

        try {
          await queryFulfilled;
          dispatch(
            api.util.updateQueryData(
              'searchProducts',
              { query, subscriptionId },
              (draft) => {
                const rowToUpdate = draft.items.find(
                  (row) => row.id === addProductRequest.productId,
                );
                // We are setting the state property in the front end to style the success state.
                // @ts-expect-error We ignore because the type is auto-generated, and the back end doesn't know about the state.
                rowToUpdate.state = UpdateStatus.Success;
              },
            ),
          );
        } catch {
          dispatch(
            api.util.updateQueryData(
              'searchProducts',
              { query, subscriptionId },
              (draft) => {
                const rowToUpdate = draft.items.find(
                  (row) => row.id === addProductRequest.productId,
                );
                // We are setting the state property in the front end to style the error state.
                // @ts-expect-error We ignore because the type is auto-generated, and the back end doesn't know about the state.
                rowToUpdate.state = UpdateStatus.Error;
              },
            ),
          );
        }
      },
    },
  },
});
